module.exports = __webpack_public_path__ + "static/assets/555edeb0630f56ca6d11d252f7b8e37f.svg";